import { render, staticRenderFns } from "./DialogPxAcertos.vue?vue&type=template&id=d5f89cf4"
import script from "./DialogPxAcertos.vue?vue&type=script&lang=js"
export * from "./DialogPxAcertos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports